angular
    .module('app')
    .component('schoolsList', {
        templateUrl: '/templates/pages/schools/schoolsList/schoolsList.html',
        controller: 'SchoolsListController',
        controllerAs: 'vm',
    });